import { Spinner } from "@dropbox/dig-components/progress_indicators";
import { Text } from "@dropbox/dig-components/typography";
import { UIIcon } from "@dropbox/dig-icons";
import { CheckmarkLine, WarningLine } from "@dropbox/dig-icons/assets";
import type { ToolCallProgressStatus } from "@mirage/mosaics/Chat/components/chat/ConversationMessages/ToolCalls/types";
import i18n from "@mirage/translations";
import { memo } from "react";

interface ToolCallStatusIndicatorProps {
  /** undefined means the tool call has not yet started */
  status: ToolCallProgressStatus | undefined;
}
export const ToolCallStatusIndicator = memo(
  ({ status }: ToolCallStatusIndicatorProps) => {
    if (status === "running") {
      return (
        <>
          <Spinner size="small" />
          <Text>{i18n.t("action_label_tool_call_status_running")}</Text>
        </>
      );
    }
    if (status === "success") {
      return (
        <>
          <UIIcon src={CheckmarkLine} size="small" />
          <Text>{i18n.t("action_label_tool_call_status_success")}</Text>
        </>
      );
    }
    if (status === "error") {
      return (
        <>
          <UIIcon src={WarningLine} size="small" />
          <Text>{i18n.t("action_label_tool_call_status_error")}</Text>
        </>
      );
    }
    return null;
  },
);
ToolCallStatusIndicator.displayName = "ToolCallStatusIndicator";
